import { mutations, state } from './mutations.js'
import * as actions from './actions'
import getters from './getters'

const namespaced = false
export default {
    namespaced,
    actions,
    getters,
    mutations,
    state,
    root: true
}